import './Subiecte.css';

export default function Subiecte2019() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2019{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectAugust2019MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectAugust2019MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremAugust2019MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectAugust2019SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectAugust2019SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremAugust2019SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectIunie2019MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectIunie2019MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremIunie2019MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Matematică-Informatică (Rezervă):</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectRezerva2019MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremRezerva2019MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectIunie2019SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectIunie2019SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremIunie2019SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectSpeciala2019MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremSpeciala2019MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectSpeciala2019SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremSpeciala2019SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectSimulare2019MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectSimulare2019MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremSimulare2019MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectSimulare2019SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectSimulare2019SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremSimulare2019SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectModel2019MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectModel2019MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremModel2019MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2019/SubiectModel2019SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2019/SubiectModel2019SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2019/BaremModel2019SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}